import EmissionGasHeader from "./Header";
import "./index.css";
import { useState } from "react";
import RefrigerationContents from "./Refrigeration";
import IndustrialContents from "./Industrial";
import SuppresantContents from "./FireSuppresant";
import { ShowHide } from "../components/ShowHideCompany";
import FlowNumbersBox from "../components/FlowNumbersBox";
import EPRBox from "../components/EPRBox";
const EmissionGasComponent = ({ businessId, mainBusinessId }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="emission-gas-container" id="gas-id">
      <EmissionGasHeader businessId={businessId} show={show} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />
        {show && (
          <EPRBox
            businessId={businessId}
            mainBusinessId={mainBusinessId}
            category={"Emission from gasses"}
          />
        )}
        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox isNormal={true} number={"Flow 3"} color={"#193666"} />
        </div>
      </div>
      {show && <RefrigerationContents businessId={businessId} />}
      {show && <IndustrialContents businessId={businessId} />}
      {show && <SuppresantContents businessId={businessId} />}
    </div>
  );
};

export default EmissionGasComponent;
